import "../../../../config/env.js";
import "../../../../config/events.js";
import { DEFAULT_FILTERS_KEYS_MAP } from "../../../../config/filters.js";
import "../../../../lib/store/createAppApi.js";
import "../../../../lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../lib/store/createAppSelector.js";
import "../../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../lib/store/hooks/useAppDispatch.js";
import "../../../../lib/store/hooks/useAppSelector.js";
import "../../../../lib/store/hooks/useAppStore.js";
import { selectSlice } from "./selectSlice.js";
const selectModels = createAppSelector(selectSlice, (config) => {
  const { models } = config;
  return {
    ...models,
    enable: (models == null ? void 0 : models.enable) ?? false,
    useGroupingByBrand: (models == null ? void 0 : models.useGroupingByBrand) ?? false,
    useAggregatePrice: (models == null ? void 0 : models.useAggregatePrice) ?? false,
    filterKey: (models == null ? void 0 : models.filterKey) ?? DEFAULT_FILTERS_KEYS_MAP.MODEL
  };
});
export {
  selectModels
};
